import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InvViewColumnViewModelStates } from '../states';
import { columnViewModelFeatureKey4 } from '../reducers/root';
export const ViewModelSelector = createFeatureSelector<InvViewColumnViewModelStates>(columnViewModelFeatureKey4);
export const selectGenericDocInvListing_State = createSelector(
  ViewModelSelector, 
 (state: InvViewColumnViewModelStates) => state.column1ViewModel.genericDocInvListingState
);